import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import _ from "lodash";
import hideMobileKeyboardOnReturn from "../plugins/utils";
import ItemsCarousel from "@/components/ItemsCarousel.vue";
import config from "@/config/custom-config";
let LentiSole = class LentiSole extends Vue {
  constructor() {
    super(...arguments);
    this.itemsType = "lentiSole";
    this.tipologia = null;
    this.lensCategory = [{
      text: "Polarizzata",
      id: "POLARIZZATA"
    }, {
      text: "Non Polarizzata",
      id: "NON POLARIZZATA"
    }, {
      text: "Grad",
      id: "GRAD"
    }, {
      text: "Specchiata",
      id: ""
    }];
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = true;
    this.scrollCounter = 0;
    this.hideMobileKeyboardOnReturn = hideMobileKeyboardOnReturn;
  }
  mounted() {}
  isItemActive(item) {
    return this.sunLens && this.sunLens.ItemCode === item.ItemCode;
  }
  get activeModelCode() {
    var _this$sunLens;
    return (_this$sunLens = this.sunLens) === null || _this$sunLens === void 0 ? void 0 : _this$sunLens.ItemCode;
  }
  get config() {
    return config;
  }
  get sunLenses() {
    return this.$store.getters["configurator/lenti/sunLenses"];
  }
  get filteredSunLenses() {
    if (!this.tipologia) {
      return this.sunLenses;
    }
    return this.sunLenses.filter(item => {
      var _this$tipologia;
      return item.ItemName.includes((_this$tipologia = this.tipologia) !== null && _this$tipologia !== void 0 ? _this$tipologia : "") && !item.ItemName.includes("NON " + this.tipologia);
    });
  }
  get sunLens() {
    return this.$store.state.configurator.lenteSole;
  }
  set sunLens(value) {
    this.$store.commit("configurator/setSunLensesModel", value);
  }
  get glassType() {
    return this.$store.state.configurator.glassType;
  }
  get user() {
    return this.$store.state.configurator.user.user;
  }
  setActiveSunLens(sunLens) {
    this.sunLens = sunLens;
  }
  scrollLeft() {
    const container = this.$refs.modelScroll;
    if (container) {
      this.scrolling = true;
      container.scrollBy({
        left: -container.clientWidth,
        behavior: "smooth"
      });
      setTimeout(() => {
        this.scrolling = false;
      }, 600);
      this.scrollCounter--;
    }
  }
  scrollRight() {
    const container = this.$refs.modelScroll;
    if (container) {
      this.scrolling = true;
      container.scrollBy({
        left: container.clientWidth,
        behavior: "smooth"
      });
      setTimeout(() => {
        this.scrolling = false;
      }, 600);
      this.scrollCounter++;
    }
  }
  noTempleAvailable() {
    if (this.filteredSunLenses.length == 0) {
      return true;
    } else {
      return false;
    }
  }
  onScrollCounterChanged(newVal) {
    this.showLeftButton = newVal > 0;
    this.showRightButton = newVal < Math.ceil(this.filteredSunLenses.length / 6) - 1;
  }
};
__decorate([Prop({
  default: false
})], LentiSole.prototype, "darkTheme", void 0);
__decorate([Watch("scrollCounter")], LentiSole.prototype, "onScrollCounterChanged", null);
LentiSole = __decorate([Component({
  components: {
    ItemsCarousel
  },
  filters: {
    capitalize: value => {
      return _.capitalize(value);
    }
  }
})], LentiSole);
export default LentiSole;